import axios, { type AxiosInstance } from 'axios';

export type HttpClientOptions = {
  /**
   * Базовый URL API приложения. Значение — путь приложения, поэтому приходит
   * параметром: пакет не знает, где живёт приложение.
   */
  baseURL: string;
};

/**
 * Транспорт всех приложений ASPID.
 *
 * Авторизация — Django-сессия и CSRF, а не заголовок с токеном:
 * `withCredentials` шлёт cookie сессии на кросс-доменные запросы, а пара
 * `xsrf*` заставляет axios переложить `csrftoken` из cookie в заголовок
 * `X-CSRFToken`. Knox-токен фронт не видит — его подставляет middleware
 * бэкенда из серверной сессии.
 */
export const createHttpClient = (options: HttpClientOptions): AxiosInstance => {
  const client = axios.create({
    baseURL: options.baseURL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    withCredentials: true,
    xsrfHeaderName: 'X-CSRFToken',
    xsrfCookieName: 'csrftoken',
    // `indexes: null` — повторяющиеся ключи без скобок: `?segment=A&segment=B`.
    // Именно так читает списки DRF. Дефолт axios пишет `segment[]=A`, и
    // бэкенд такой параметр не разбирает. Настройка стояла только у deals.
    // eslint-disable-next-line unicorn/no-null -- null здесь значение из схемы axios, а не «пусто»
    paramsSerializer: { indexes: null },
  });

  client.interceptors.request.use((config) => {
    // A generated multipart request omits Content-Type so Axios can add its
    // boundary. The shared JSON default would otherwise serialize the file.
    if (config.data instanceof FormData) config.headers.delete('Content-Type');
    return config;
  });

  return client;
};
